import { Link } from "react-router-dom";
import { Dumbbell, Heart, Users, Zap, Github } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND_XEVIAN_LOGO } from "@/lib/brandAssets";

export default function About() {
  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-20 px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-display font-bold mb-4 text-foreground">
            About TA Fitness
          </h1>
          <p className="text-lg text-muted-foreground mb-8">
            Your comprehensive fitness companion designed to transform your health and wellness journey.
          </p>
          <Link to="/">
            <Button>Back to Dashboard</Button>
          </Link>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16 px-4 md:px-8 bg-muted/30">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-display font-bold mb-8 text-foreground text-center">Our Mission</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="rounded-xl bg-card p-6 border border-border">
              <Heart className="w-10 h-10 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-2 text-foreground">Health First</h3>
              <p className="text-muted-foreground">
                We believe fitness is about creating sustainable, healthy habits that last a lifetime.
              </p>
            </div>
            <div className="rounded-xl bg-card p-6 border border-border">
              <Dumbbell className="w-10 h-10 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-2 text-foreground">Expert Training</h3>
              <p className="text-muted-foreground">
                Connect with certified trainers who personalize your fitness journey to your unique goals.
              </p>
            </div>
            <div className="rounded-xl bg-card p-6 border border-border">
              <Users className="w-10 h-10 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-2 text-foreground">Community</h3>
              <p className="text-muted-foreground">
                Be part of a supportive community that celebrates every milestone and breakthrough.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-display font-bold mb-8 text-foreground text-center">Why Choose TA Fitness?</h2>
          <div className="space-y-4">
            <div className="flex gap-4 items-start p-4 rounded-xl bg-muted/40 border border-border">
              <Zap className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-foreground mb-1">Personalized Workouts</h3>
                <p className="text-muted-foreground text-sm">Customized training plans tailored to your fitness level and goals.</p>
              </div>
            </div>
            <div className="flex gap-4 items-start p-4 rounded-xl bg-muted/40 border border-border">
              <Zap className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-foreground mb-1">Nutrition Guidance</h3>
                <p className="text-muted-foreground text-sm">Access meal plans and dietary advice from certified nutritionists.</p>
              </div>
            </div>
            <div className="flex gap-4 items-start p-4 rounded-xl bg-muted/40 border border-border">
              <Zap className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-foreground mb-1">Progress Tracking</h3>
                <p className="text-muted-foreground text-sm">Monitor your fitness journey with detailed progress logs and analytics.</p>
              </div>
            </div>
            <div className="flex gap-4 items-start p-4 rounded-xl bg-muted/40 border border-border">
              <Zap className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-foreground mb-1">Expert Support</h3>
                <p className="text-muted-foreground text-sm">Work with professional trainers who guide you every step of the way.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Developer Info Section */}
      <section className="py-16 px-4 md:px-8 bg-muted/30">
        <div className="max-w-4xl mx-auto text-center">
          <div className="rounded-xl bg-card p-8 border border-border">
            <div className="flex justify-center mb-4">
              <img 
                src={BRAND_XEVIAN_LOGO} 
                alt="XevianSoftware Logo"
                className="h-20 object-contain"
              />
            </div>
            <h2 className="text-2xl font-display font-bold mb-3 text-foreground">Developed By</h2>
            <p className="text-lg text-primary font-semibold mb-2">XevianSoftware</p>
            <p className="text-muted-foreground">
              Built with passion and precision to deliver the best fitness experience.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}